
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('rect',{attrs:{"x":"3","y":"2","width":"9","height":"20","rx":"1"}})]),_c('rect',{attrs:{"x":"3","y":"2","width":"9","height":"20","rx":"1","stroke":"currentColor","stroke-width":"2.8","stroke-linejoin":"round","mask":"url(#a)"}}),_c('path',{attrs:{"d":"M4 6h4M4 9h4M4 12h4M4 15h4M7 18h1","stroke":"currentColor","stroke-width":"1.2","stroke-linecap":"round"}}),_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('rect',{attrs:{"x":"11","y":"8","width":"10","height":"14","rx":"1"}})]),_c('rect',{attrs:{"x":"11","y":"8","width":"10","height":"14","rx":"1","stroke":"currentColor","stroke-width":"2.8","stroke-linejoin":"round","mask":"url(#b)"}}),_c('path',{attrs:{"d":"M12 12h5M12 15h5M15 18h1","stroke":"currentColor","stroke-width":"1.2","stroke-linecap":"round"}})])
          )
        }
      }
    